import React, { useEffect } from 'react';
import { SearchBar } from '../../tailwind/molecules';

const SearchBarCard = ({ searchAction, heading, description, searchList, searchValues, classes }) => {
  useEffect(() => {
    const onEnter = (event) => {
      if (event.keyCode === 13 && event.target.name === 'input-search') {
        const value = event.target.value;
        if (value.trim()) searchAction(value);
      }
    };
    document.addEventListener('keyup', onEnter);
    return () => document.removeEventListener('keyup', onEnter);
  }, []);
  const length = searchList.length;
  return (
    <div className={'bg-white border border-gray-200 p-6 rounded-md ' + classes}>
      <h1 className='text-lg text-gray-800 leading-4 font-semibold'>{heading}</h1>
      <p className='mb-0 mt-2 text-gray-600 leading-4'>{description}</p>
      <div className='grid grid-cols-3 gap-6'>
        {searchList.map((item, ind) => {
          return (
              <div key={ind}>
                <p className='text-gray-500 text-xs tracking-widest mt-8 mb-3 leading-3 p-0 font-semibold uppercase'>{item}</p>             
                < SearchBar 
                  searchIconClasses='top-4 left-3'
                  classes='mb-6'
                  placeholder='Search'
                  inputClasses='px-3 rounded-md py-3.5 pl-10 h-12 text-base leading-4 placeholder-gray-300 text-gray-600 bg-gray-100 focus:bg-gray-100'
                  handler={searchAction}
                  clearIconClasses='top-4 -mt-0.5 right-3'
                />
              </div> 
            )})
        }
      </div>
    </div>
  );
};

export default SearchBarCard;
